import { Type } from 'typebox';
import { Value } from 'typebox/value';
import { DocumentationEvent, Event, isDocumentationEventType, isRecord, toMillis } from '@tadpoles/common';
export const EventsRequest = Type.Union([
    Type.Object({
        direction: Type.Literal('range'),
        cursor: Type.Optional(Type.String()),
        earliestEventTime: Type.Optional(Type.Number()),
        latestEventTime: Type.Optional(Type.Number())
    }),
    Type.Object({
        direction: Type.Literal('newer'),
        cursor: Type.Optional(Type.String()),
        latestUpdateTime: Type.Optional(Type.Number())
    })
]);
const RawEventsPayload = Type.Object({
    events: Type.Array(Type.Unknown()),
    cursor: Type.Optional(Type.String()),
    linkedEvents: Type.Array(Type.Unknown())
});
export class HttpEventsResource {
    #httpClient;
    constructor(httpClient) {
        this.#httpClient = httpClient;
    }
    async list(query, options) {
        const response = await this.#httpClient.post({
            body: this.#normalizeQuery(query),
            bodySchema: EventsRequest,
            path: '/events/query',
            payloadSchema: RawEventsPayload,
            signal: options?.signal
        });
        return {
            events: response.events.map((event) => this.#decodeEvent(event)),
            cursor: response.cursor,
            linkedEvents: response.linkedEvents.map((event) => this.#decodeEvent(event))
        };
    }
    #normalizeQuery(query) {
        if (query.direction === 'range') {
            const earliestEventTime = toMillis(query.earliestEventTime);
            const latestEventTime = toMillis(query.latestEventTime);
            if (typeof earliestEventTime !== 'number' && typeof latestEventTime !== 'number') {
                throw new Error('Range event queries must include earliestEventTime or latestEventTime');
            }
            return {
                direction: query.direction,
                cursor: query.cursor,
                earliestEventTime,
                latestEventTime
            };
        }
        return {
            direction: query.direction,
            cursor: query.cursor,
            latestUpdateTime: toMillis(query.latestUpdateTime)
        };
    }
    #decodeEvent(value) {
        if (!isRecord(value)) {
            throw new Error('Expected event payload to be an object');
        }
        if (isDocumentationEventType(value['type'])) {
            return Value.Decode(DocumentationEvent, value);
        }
        return Value.Decode(Event, value);
    }
}
